import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS, SUMMARY_ROUTES } from 'cpool-constants';
import { schemaLoanRequestResolver_GetCounts } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

const BUCKET_COUNT_REFETCH_INTERVAL = 30_000;

export const useBucketCounts = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getCounts,
        schema: schemaLoanRequestResolver_GetCounts,
        searchParams: {
            route: SUMMARY_ROUTES.BUCKET_LEADS,
        },
        tanstack: {
            refetchInterval: BUCKET_COUNT_REFETCH_INTERVAL,
        },
    });
};
